<div class="position-relative"  id="{{'item-' + kudos.id}}">
    <div class="media card kudos-card position-relative" id="{{kudos.id}}">
        <div class="kudos-badge">
            <span>{{'kudos.type.'+kudos.kudosType | translate}} - </span>{{'Kudos' | translate }}
            @if(kudos?.privacy === 'private'){
            <private-badge></private-badge>
            }
            @if(kudos.reviewed.length > 0){
            <review-badge [reviewInfo]="kudos.reviewed"></review-badge>
            }
        </div>
        <div class="card-top" (mouseenter)="showTimelineItemOptions=true" (mouseleave)="showTimelineItemOptions=false">
            <div class="pe-2">
                @switch (kudos.kudosType){
                    @case ('thanks'){
                        <i class="fa-light fa-hands-holding-heart hands-holding-heart-icon ms-2 position-relative"
                           [ngClass]="{'text-secondary': timelineItemEditMode}"></i>
                    }
                    @case ('congratulate'){
                        <i class="fa-light fa-hands-clapping fa-2x ms-2 position-relative"
                           [ngClass]="{'text-secondary': timelineItemEditMode}"></i>
                    }
                    @case ('celebrate'){
                        <i class="fa-sharp fa-light fa-party-horn fa-2x ms-2 position-relative"
                           [ngClass]="{'text-secondary': timelineItemEditMode}"></i>
                    }
                }
            </div>
            @if (!timelineItemEditMode){
            <div class="w-100">
                <tm-kudos-recipients-display [recipients]="kudos.recipients" [author]="kudos.author"></tm-kudos-recipients-display>
                <div class="card-comment p-3">
                    <span class="card-comment-body fst-italic" [innerHtml]="kudos.message.body | removeGifUrls: kudos.message.linkPreviews | linky"></span>
                    @for (linkPreview of kudos.message.linkPreviews; track linkPreview.url){
                    @if(linkPreview.url.slice(-4) === '.gif'){
                    <tm-gif-preview [gifPreview]="toGifPreview(linkPreview)"></tm-gif-preview>
                    }
                    }
                </div>
            </div>
            } @else {
            <tm-edit-kudos-box
                    [kudos]="kudos"
                    [teamId]="teamId"
                    (onEdit)="onKudosEdited($event)"
                    (onCancel)="cancelEdit()"></tm-edit-kudos-box>
            }

            @if(!(isHandset$ | async)){
            <div class="card-options" [ngClass]="{'active-options': showTimelineItemOptions}">
                @if(!timelineItemEditMode){
                <div>
                    @if(kudos.isEditable){
                    <div (click)="editKudos()">
                        <i class="fa-regular fa-pen"
                           [matTooltip]="'kudos.card.options.edit' | translate"
                           matTooltipPosition="right">
                        </i>
                    </div>
                    }
                    @if(kudos.isDeletable){
                    <div (click)="deleteKudos()">
                        <i class="fa-regular fa-trash-alt"
                           data-cy="delete-kudos"
                           [matTooltip]="'kudos.card.options.delete' | translate"
                           matTooltipPosition="right">
                        </i>
                    </div>
                    } @else {
                    <div (click)="reportKudos()">
                        <i class="fa-regular fa-hexagon-exclamation"
                           [matTooltip]="'kudos.card.options.report' | translate"></i>
                    </div>
                    }
                </div>
                }
            </div>
            } @else {
                @if(!timelineItemEditMode){
                    <div class="card-options card-options-mobile">
                        <button class="btn btn-secondary dropdown-toggle" type="button" [matMenuTriggerFor]="menu">
                            <i class="fa-regular fa-ellipsis-vertical"></i>
                        </button>
                        <mat-menu #menu="matMenu">
                            <ul class="p-0 m-0">
                                @if(kudos.isEditable){
                                    <li mat-menu-item class="dropdown-item" (click)="editKudos()">
                                        <i class="fa-regular fa-pen pe-1"></i> {{'kudos.card.options.edit' | translate }}
                                    </li>
                                    }
                                @if(kudos.isDeletable){
                                    <li  mat-menu-item class="dropdown-item" (click)="deleteKudos()">
                                        <i class="fa-regular fa-trash-alt pe-1"></i> {{'kudos.card.options.delete' | translate }}
                                    </li>
                                } @else {
                                    <li  mat-menu-item class="dropdown-item" (click)="reportKudos()">
                                        <i class="fa-regular fa-hexagon-exclamation pe-1"></i> {{'kudos.card.options.report' | translate }}
                                    </li>
                                }
                            </ul>
                        </mat-menu>
                    </div>
                }
            }
        </div>


        @if(!timelineItemEditMode){
        <div  (mouseenter)="showTimelineItemOptions=true" (mouseleave)="showTimelineItemOptions=false">
        @for(linkPreview of kudos.message.linkPreviews; track linkPreview.url){
            @if(linkPreview.url.slice(-4) !== '.gif'){
            <div>
                <tm-link-preview [linkPreview]="linkPreview"></tm-link-preview>
            </div>
            }
        }
        </div>

        <div class="media-bottom card-bottom">
            <tm-reactions [timelineItem]="kudos"
                       (onReacted)="onReacted($event)"
                       (onToggleThreads)="toggleThreads()"
                       (onDiscuss)="discuss()"></tm-reactions>

            @if(showThreads){
            <tm-threads [timelineItem]="kudos" #threadsComponent
                        [userInfos]="userInfos"
                        (onThreadsUpdated)="onThreadsUpdated($event)"></tm-threads>
            }
        </div>
        }
    </div>

    <!-- @if (kudos.educationalCard){
    <div class="position-absolute mb-md-3 hide-for-mobile top-0 start-100 ms-4"
         [class]="{'hide-for-large-screen': !isOdd, 'hide-oft': isOdd }">
        <tm-educational-card
                [educCardId]="kudos.educationalCard"
                [threadComponent]="getThreadsComponent"></tm-educational-card>
    </div>
    } -->
    @if(kudos.managerPanel){
        <div class="manager-panel-wrapper"
             [class]="isOdd ? 'odd-timeline-item': 'even-timeline-item'">
            <tm-manager-panel [managerPanel]="kudos.managerPanel"
                              [reviewed]="kudos.reviewed.length !== 0"></tm-manager-panel>
        </div>
    }
</div>

